import { Children, ReactNode } from 'react';

import { Grid, Portal } from '@mui/material';

import { usePortal } from 'hooks/common';

interface ActionButtonsProps {
  children?: ReactNode;
  isInvisible?: boolean;
}

const ActionButtons = ({ children, isInvisible }: ActionButtonsProps) => {
  const containerRef = usePortal('sticky-header-wrapper');

  return (
    <Portal container={containerRef}>
      <Grid
        container
        spacing={1}
        sx={{
          visibility: isInvisible ? 'hidden' : 'visible',
          minWidth: '20vw',
          '&.MuiGrid-spacing-xs-1': {
            mr: 0,
            mb: 0,
            '.MuiGrid-item': {
              pb: 0,
              pr: 0,
            },
          },
          '.MuiGrid-spacing-xs-1': { pb: 0, pr: 0 },
        }}
        justifyContent="flex-end"
      >
        {Children.map(children, child => child && <Grid item>{child}</Grid>)}
      </Grid>
    </Portal>
  );
};

export default ActionButtons;
